import { gql } from "@grandvisionhq/graphql";
import { variantProductPriceItem } from "./variant-product-price-item.js";
const variantFragment = gql`
  fragment VariantFragment on Variant {
    sku
    displayName
    isAvailableForSubscription
    priceList {
      ...VariantProductPriceItemFragment
    }
    ... on ContactLensVariant {
      variantTypeDetails {
        subscriptionIntervals
      }
    }
    ... on SolutionVariant {
      variantTypeDetails {
        subscriptionIntervals
      }
    }
  }
  ${variantProductPriceItem}
`;
export {
  variantFragment
};
//# sourceMappingURL=variant.js.map
